'use client'
import React, { useEffect, useRef, useState } from 'react'
import { motion } from 'framer-motion'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
const Slider = dynamic(() => import('react-slick'), { ssr: false });
import { ChevronLeft, ChevronRight } from 'lucide-react';

import FleetsCardsSkeleton from './FleetsCardsSkeleton'
import FleetsCardsLayout from './FleetsCardsLayout'
import getSlickSettings from 'src/constants/slickSettings'
import dynamic from 'next/dynamic';
import FleetTabs from './FleetTabs'

const AirportFleet = ({ changeCurrLoading, searchedFleetData, isNoData , isShowRate , isShowSkeletonTabs = false}) => {
  const contentRef = useRef()
  const [data, setData] = useState({})
  const [activeTab, setActiveTab] = useState({ key: 'LCY', index: 0 })
  const [horizontalScrollPercentage, setHorizontalScrollPercentage] =
    useState(0)
  const [hasInitialized, setHasInitialized] = useState(false)

  const sliderSettings = getSlickSettings(data[activeTab.key]?.length , 'default')

  useEffect(() => {
    setHorizontalScrollPercentage(0)
  }, [])

  useEffect(() => {
    const initializeData = async () => {
      if (!hasInitialized) {
        setHasInitialized(true)
        setActiveTab({ key: Object.keys(searchedFleetData)[0], index: 0 })
        setData(searchedFleetData)
      }
    }
    initializeData()
  }, [searchedFleetData, isNoData])

  useEffect(() => {
    setData(searchedFleetData)
    setActiveTab({ key: Object.keys(searchedFleetData)[0], index: 0 })
  }, [searchedFleetData])

  const handelChangeActiveTab = (key, index) => {
    setActiveTab({ ...activeTab, key: key, index: index })
  }
  const handleScrollTabsContainer = (n) => {
    const tabsContainer = document.querySelector('#fleet-tabs-container')

    const scrollPercentage =
      (tabsContainer.scrollLeft /
        (tabsContainer.scrollWidth - tabsContainer.clientWidth)) *
      100

    setHorizontalScrollPercentage(Math.ceil(scrollPercentage))
    tabsContainer.scrollBy({
      left: n,
      behavior: 'smooth',
    })
  }
  return Object.keys(data).length ? (
    <div className='w-full max-w-full min-h-[340px]'>
      <FleetTabs  data={data} activeTab={activeTab} setActiveTab={setActiveTab} />
      <Slider {...sliderSettings}>
        {data[activeTab.key]?.map((item, index) => 
        {
          if(item?.name === 'Toyota Prius' || item?.name === 'Volkswagen Multivan') return
        return (
           <FleetsCardsLayout
           item={item}
           key={item.name + index}
           index={index}
           activeTab={activeTab}
           changeCurrLoading={changeCurrLoading}
           isShowRate= {isShowRate}
         />
        )})}
      </Slider>
    </div>
  ) : (
    <>
      <FleetsCardsSkeleton isShowSkeletonTabs = {isShowSkeletonTabs} />
    </>
  )
}

export default AirportFleet
